import React from "react";

const HeaderBanner = () => {
  return (
    <div className="text-3xl text-center text-white bg-_purple p-3 font-semibold 3xl:p-5 3xl:text-[2.7rem] 3xl:font-bold">
      REACT<span className="text-_yellow">JS</span>
    </div>
  );
};

export default HeaderBanner;
